// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.submittal-builder, .submitted {
  padding:1em 0.25em;
}

.wizard {
  width:100%;
  display:inline-block;
}

.submittal-builder {
  vertical-align:top;
}
mat-horizontal-stepper {
  background:transparent;
}
mat-step {
  background:blue;
}

.submitted .clear {
  text-align:left;
  margin-top:2em;
}

mat-card.compact {
  padding:0.333em 0.5em;
}

.clear {
  text-align:right;
}

.submittal {
  display:none;
}

.see-submittal {
  margin:0 3vw;
  width:94vw;
}
.see-submittal button {
  width:46vw;
  text-slign:center;
  padding:1vw;
}
.not-mobile {
  display:none;
}

.download:hover img {
  box-shadow: 6px 5px 10px -1px rgba(230, 48, 43, 0.8),
              0 1px 10px 0 rgba(230, 48, 43, 0.8),
              0 1px 10px 0 rgba(230, 48, 43, 0.8);
}

@media only screen and (min-width:30em) {
  .not-mobile {
    display:inline-block;
  }
}

@media only screen and (min-width:50em) {
  .submittal-builder, .submitted {
    padding: 2em;
  }

  .wizard {
    width: 69%;
  }

  .see-submittal {
    display: none;
  }

  .submittal {
    width: 30%;
    margin-left: 1%;
    display: inline-block;
    background: rgba(0, 0, 0, 0.2);
    min-height: 20em;
    padding: 1em;
    vertical-align: top;
    margin-top: 6em;
  }
  ng-tmeplate br {
    display:none;
  }
}

@media only screen and (min-width:80em) {

}
`, "",{"version":3,"sources":["webpack://./src/app/pages/submittal/submittal.component.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,YAAY;AACd;;AAEA;EACE;;iDAE+C;AACjD;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,UAAU;IACV,eAAe;IACf,qBAAqB;IACrB,8BAA8B;IAC9B,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,YAAY;EACd;AACF;;AAEA;;AAEA","sourcesContent":[".submittal-builder, .submitted {\n  padding:1em 0.25em;\n}\n\n.wizard {\n  width:100%;\n  display:inline-block;\n}\n\n.submittal-builder {\n  vertical-align:top;\n}\nmat-horizontal-stepper {\n  background:transparent;\n}\nmat-step {\n  background:blue;\n}\n\n.submitted .clear {\n  text-align:left;\n  margin-top:2em;\n}\n\nmat-card.compact {\n  padding:0.333em 0.5em;\n}\n\n.clear {\n  text-align:right;\n}\n\n.submittal {\n  display:none;\n}\n\n.see-submittal {\n  margin:0 3vw;\n  width:94vw;\n}\n.see-submittal button {\n  width:46vw;\n  text-slign:center;\n  padding:1vw;\n}\n.not-mobile {\n  display:none;\n}\n\n.download:hover img {\n  box-shadow: 6px 5px 10px -1px rgba(230, 48, 43, 0.8),\n              0 1px 10px 0 rgba(230, 48, 43, 0.8),\n              0 1px 10px 0 rgba(230, 48, 43, 0.8);\n}\n\n@media only screen and (min-width:30em) {\n  .not-mobile {\n    display:inline-block;\n  }\n}\n\n@media only screen and (min-width:50em) {\n  .submittal-builder, .submitted {\n    padding: 2em;\n  }\n\n  .wizard {\n    width: 69%;\n  }\n\n  .see-submittal {\n    display: none;\n  }\n\n  .submittal {\n    width: 30%;\n    margin-left: 1%;\n    display: inline-block;\n    background: rgba(0, 0, 0, 0.2);\n    min-height: 20em;\n    padding: 1em;\n    vertical-align: top;\n    margin-top: 6em;\n  }\n  ng-tmeplate br {\n    display:none;\n  }\n}\n\n@media only screen and (min-width:80em) {\n\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
